import classNames from "classnames";
import lodash from "lodash";
import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import generalRTLIgnoredStyles from "./../wix-rich-content-common/statics/styles/general.rtlignore-scss.js";
import generalStyles from "./../editor-common/statics/styles/general-scss.js";
const stylesWithRTL = { ...generalStyles, ...generalRTLIgnoredStyles };
const getAlignmentClassName = (alignment) => {
  if (!alignment || alignment === PluginContainerData_Alignment.UNRECOGNIZED) {
    return "";
  }
  return stylesWithRTL[`align${lodash.upperFirst(alignment.toLowerCase())}`];
};
const getSizeClassName = (size) => {
  if (!size || size === PluginContainerData_Width_Type.UNRECOGNIZED) {
    return "";
  }
  return stylesWithRTL[`size${lodash.upperFirst(lodash.camelCase(size))}`];
};
const getTextWrapClassName = (textWrap) => textWrap === false ? stylesWithRTL.textWrapNowrap : "";
const isCustomWidthDisabled = (node, isMobile) => {
  if (node.type.name === Node_Type.IMAGE) {
    const componentData = node.attrs;
    return !!(isMobile && componentData?.image?.width && Number(componentData?.containerData?.width?.custom || 0) > 150);
  }
  return false;
};
const getOriginalWidth = (node) => {
  switch (node.type.name) {
    case Node_Type.IMAGE:
      return node.attrs?.image?.width;
    case Node_Type.GIF:
      return node.attrs?.width;
    default:
      return void 0;
  }
};
const getPluginContainerClassNames = (isMobile) => classNames(stylesWithRTL.pluginContainer, isMobile && stylesWithRTL.pluginContainerMobile);
const getPluginPlacementClassNames = (node, isTextWrapEnabled) => {
  const containerData = node.attrs?.containerData;
  return classNames(
    getAlignmentClassName(containerData?.alignment),
    getSizeClassName(containerData?.width?.size),
    getTextWrapClassName(isTextWrapEnabled && containerData?.textWrap)
  );
};
const getPluginFocusClassNames = (isFocused) => classNames(
  stylesWithRTL.isFocusable,
  isFocused && stylesWithRTL.hasFocus,
  !isFocused && stylesWithRTL.hideTextSelection
);
const getNodeWidth = (node, isMobile) => {
  const containerData = node.attrs?.containerData;
  const disableCustomWidth = isCustomWidthDisabled(node, isMobile);
  const customWidth = !disableCustomWidth && containerData?.width?.custom;
  const originalWidth = (containerData?.width?.size === "ORIGINAL" || disableCustomWidth) && getOriginalWidth(node);
  return customWidth || originalWidth;
};
export {
  getNodeWidth,
  getPluginContainerClassNames,
  getPluginFocusClassNames,
  getPluginPlacementClassNames
};
//# sourceMappingURL=node-styles.js.map
